const ServerEnv = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  ALPHA: 'alpha',
  PRODUCTION: 'production',
};

export default ServerEnv;
